import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { CustomReminderService } from 'app/core/services/custom-reminder.service';
import { QuillService } from 'app/core/services/quill.service';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { QuillCustomComponent } from '../quill-custom/quill-custom.component';
import { MdbpInputComponent } from '../mdb-input/mdb-input.component';
import { select, Store } from '@ngrx/store';
import { selectCurrentAuction } from 'app/manage-auctions/features/auction.selectors';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { TransformStringPipe } from 'app/core/pipes/transform-string.pipe';

@Component({
  standalone: true,
  imports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    MdbTabsModule,
    MdbValidationModule,
    QuillCustomComponent,
    MdbpInputComponent, 
    MdbSelectModule,
    TransformStringPipe],
  selector: 'app-custom-reminder',
  templateUrl: './custom-reminder.component.html',
  styleUrl: './custom-reminder.component.scss'
})
export class CustomReminderComponent implements OnInit,AfterViewInit,OnDestroy {
  destroyRef = inject(DestroyRef)
  private observer: MutationObserver;
  @ViewChild('insertTypeSubject') insertTypeSubject:ElementRef;
  @ViewChild('insertTypeBody') insertTypeBody:ElementRef;

  @Input() templates:any = []; 
  @Input() isCampaignConnected:boolean;
  @Input() modalName:string
  @Input() eventId:string = null;
  @Input() templatesType: number = 0;
  public customReminderSubject = new UntypedFormControl();
  public customReminderBody = new UntypedFormControl();
  public customReminderName = new UntypedFormControl();
  public select = new UntypedFormControl();
  public dialog: any = null;

  public activeScreen = 'templateList'
  public templateList = [];
  public templateActiveList = [];
  public templateInActiveList = [];
  public selectedEditTemplate = null;
  // public selectedTemplate = null;

  public quillSubjectOptions = { 
    savingId:'subject', 
    disableEditAndInsertEdited: true 
  }
  public quillBodyOptions = { 
    savingId:'body', 
    showToolbarList:true, 
    showImage: true 
  }

  // public disabledUpdateBtn = true;

  public insertBodyBlocks = [];

  public insertSubjectBlocks= [];
  
  constructor(
    public quillService:QuillService,
    public customReminderService:CustomReminderService,
    private store:Store,
    private el: ElementRef,
  ){}

  private currentAuction = null;
  private currentAuction$ = this.store.pipe(
    takeUntilDestroyed(this.destroyRef),
    select(selectCurrentAuction),
  )


  ngOnInit(): void {
    this.setTemplateValues();
    this.loadTemplateList();
    this.customReminderSubject.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value)=>{
      this.customReminderSubject.setErrors(null)
    })
    this.customReminderBody.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value)=>{
      this.customReminderBody.setErrors(null)
    })
    this.customReminderName.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value)=>{
      this.customReminderName.setErrors(null)
    })

    this.currentAuction$.subscribe(auction => {
      this.currentAuction = auction;
    })
  }

  ngAfterViewInit(): void {
    this.observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // this component is used in angular and jquery part of the application
          // because of this, scss files form-control and _form-control.scss may cause css styles to conflict
          // to solve the conflict we need to get rid of form-outline class that is used in form-control.scss
          // and to overide some styles in quill-editor and character-counter
          $(this.el.nativeElement)
            .find('.form-outline')
            .removeClass('form-outline');
        }
      }
    });

    this.observer.observe(this.el.nativeElement, {
      childList: true, // observe direct children
      subtree: true,   // observe all descendants
      attributes: false,
      characterData: false,
    });

    $(this.el.nativeElement)
    .find('.form-outline')
    .removeClass('form-outline');
  }

  ngOnDestroy(): void {
    this.observer.disconnect()
  }

  setTemplateValues(){
    if((this.templatesType === window['orgMain'].emailTemplateTypes.Auction)){
      this.insertBodyBlocks = [
        { name: 'Bidder Name', value: '.BidderName' },
        { name: 'All Bids', value: '.AllBids' }
      ]

      this.insertSubjectBlocks = [
        { name: 'Bidder Name', value: '.BidderName' },
      ]
    } else{
      this.insertBodyBlocks = [
        {name:'Donor Name',value:'.DonorName'},
        {name:'Organization Name',value:'.OrgName'},
        {name:'Campaign Name',value:'.CampaignName'},
        {name:'Check-In QR Code',value:'.TicketQRCodeBlock'},
      ]
    
      this.insertSubjectBlocks = [
        {name:'Donor Name',value:'.DonorName'},
        {name:'Organization Name',value:'.OrgName'},
        {name:'Campaign Name',value:'.CampaignName'},
      ]
    }

    if(this.isCampaignConnected && this.templatesType != window['orgMain'].emailTemplateTypes.Auction ){
      this.insertBodyBlocks.push({name:'Save Card Button',value:'.SaveCardButton'});
    }
  }

  loadTemplateList(){
    let templates = this.templates;
    if(templates.length){
      this.templateList = [...templates]
      this.templateActiveList = templates.filter((templete)=>(!templete.status)).map(temp=>{
        temp.checked = false
        return temp
      } )
      this.templateInActiveList = templates.filter((templete)=>(templete.status))
    }
  }

  getAllTemplates(){
    this.customReminderService.getAllTemplates(this.templatesType)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((list:any)=>{
      if(!list || list.length === 0){
        window['orgMain'].selectedTemplate = null;
      }

      if(list.length){
        this.templateList = [...list]
        this.templateActiveList = list.filter((templete)=>(!templete.status)).map(temp=>{
          temp.checked = false
          return temp
        } )
        this.templateInActiveList = list.filter((templete)=>(templete.status))
      }
    })
  }

  onCreateTemplate(){
    this.activeScreen = 'createTemplate'
    this.initialiseInsertSelect()
    this.clearControls();

    this.updateHeaders('create',this.modalName)
  }

  editTemplate(template){
    this.activeScreen = 'updateTemplate'
    this.selectedEditTemplate = template;
    this.initialiseInsertSelect()
    this.customReminderSubject.setValue(template.subject)
    this.customReminderBody.setValue(template.body)
    this.customReminderName.setValue(template.name)

    this.updateHeaders('edit',this.modalName)
  }


  initialiseInsertSelect(){
    let self = this
    setTimeout(() => {
      let $ =  window['$'];
      $(this.insertTypeBody.nativeElement).materialSelect({destroy:true})
      $(this.insertTypeBody.nativeElement).materialSelect()
      
  
      $(this.insertTypeBody.nativeElement).off("change")
      $(this.insertTypeBody.nativeElement).change(function(){
        let value  =  $(self.insertTypeBody.nativeElement).val()
        let selection = self.quillService.selectionMap.get('body')
        self.quillService.quillInstanceMap.get('body').insertText(selection, `{{${value}}}`, true)
        $(self.insertTypeBody.nativeElement).val('insertBody')
      });

      $(this.insertTypeSubject.nativeElement).materialSelect({destroy: true})
      $(this.insertTypeSubject.nativeElement).materialSelect();
  
      $(this.insertTypeSubject.nativeElement).off("change")
      $(this.insertTypeSubject.nativeElement).change(function(){
        let value  = $(self.insertTypeSubject.nativeElement).val()
        let selection = self.quillService.selectionMap.get('subject');
          self.quillService.quillInstanceMap.get('subject').insertText(selection, `{{${value}}}`, true)
          $(self.insertTypeSubject.nativeElement).val('insertSubject')
      });
    },100)
  }

  onDeleteTemplateClick(template,activate = false){
    this.customReminderService.deactivateTemplates(template.id, activate)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(()=>{
        this.getAllTemplates()
      })
  }

  updateHeaders(type, modalName){
    switch (type) {
      case 'remainderScreen':
          let headers = window['orgMain'].previousHeaders
          $(`#${modalName}Header`).text(headers.header)
          $(`#${modalName}SubHeader`).text(headers.subHeader)
        break
      case 'list':
        $(`#${modalName}Header`).text('Manage Templates')
        $(`#${modalName}SubHeader`).text('Create or manage your custom templates.')
        break
      case 'create':{
        $(`#${modalName}Header`).text('Create A Template')
        let subHeaderText = '';
        if (this.templatesType === window['orgMain'].emailTemplateTypes.Auction){
          subHeaderText = 'Create a new email template to be sent to all bidders in this auction. Insert necessary elements to the subject and body.'
        } else {
          subHeaderText = 'Create a new email template to be sent to all guests in your guest list. Insert necessary elements to the subject and body.'
        }

        $(`#${modalName}SubHeader`).text(subHeaderText)
        break
      }
      case 'edit': {
        let subHeaderText = '';
        if (this.templatesType === window['orgMain'].emailTemplateTypes.Auction){
          subHeaderText = 'Update a new email template to be sent to all bidders in this auction. Insert necessary elements to the subject and body.'
        } else {
          subHeaderText = 'Update a new email template to be sent to all guests in your guest list. Insert necessary elements to the subject and body.'
        }
        $(`#${modalName}Header`).text('Update Template')
        $(`#${modalName}SubHeader`).text(subHeaderText)
        break
      }
    }
  }

  goToTemplateList() {
    this.activeScreen = 'templateList';
    this.updateHeaders('list', this.modalName);
  }

  onClickCreateOrUpdate(status, prewiew = false){
    if(!this.validate()){
      return
    }

    const params = {
      name: this.customReminderName.value,
      subject: this.customReminderSubject.value,
      body: this.customReminderBody.value,
      type: this.templatesType,
    }

    if (status == 'create') {
      this.customReminderService.createTemplates(params)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(val=>{
          if(prewiew){
            this.templatePrewiew(val)
          }
          this.getAllTemplates()
          this.activeScreen = 'templateList'
          this.updateHeaders('list', this.modalName)
      })
    } else if(status == 'update') {
      params['id'] = this.selectedEditTemplate.id,
      this.customReminderService.updateTemplates(params)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(val=>{
          if(prewiew){
            this.templatePrewiew(val)
          }
          this.getAllTemplates()
          this.activeScreen = 'templateList'
          this.updateHeaders('list', this.modalName)
      })
    }
  }

  templatePrewiew(template) {
    const self = this;

    function ticketReminderPreview() {
      const params = {
        emailHeader:'',
        message: '',
        sendSMS: false,
        preview: true,
        templateId: template.id
      }

      if(self.eventId) {
        params['eventId'] = self.eventId;
        window['orgMain'].sendEventGuestReminderAll(params);
        
      } else {
        params['campaignId'] = window['ticketingAndGuestsModal'].campaign.id;
        window['orgMain'].sendTicketReminderAll(params);
      }
    }
    
    function allBiddersReminderPreview(){
      if(!self.currentAuction){
        return;
      }

      const params = {
        campaignId: self.currentAuction.id,
        templateId: template.id,
        preview: true
      }

      window['orgMain'].sendNotifyAllBiddiersReminder(params)
    }

    if (template.type === window['orgMain'].emailTemplateTypes.Auction){
      allBiddersReminderPreview()
    } else {
      ticketReminderPreview()
    }
  }

  validate(){
    if(this.customReminderName.value == ''){
      this.customReminderName.setErrors({'incorrect': true})
      return false
    }
    if(this.customReminderSubject.value == ''){
      this.customReminderSubject.setErrors({'incorrect': true})
      return false
    }
    if(this.customReminderBody.value == ''){
      this.customReminderBody.setErrors({'incorrect': true})
      return false
    }
    return true
  }

  clearControls(){
    this.customReminderSubject.setValue('')
    this.customReminderBody.setValue('')
    this.customReminderName.setValue('')

  }

  onBackClick() {
    let $ =  window['$'];
    let orgMain = window['orgMain'];
    let self = this
    this.updateHeaders('remainderScreen',this.modalName)
    orgMain.getAllEmailTemplate(this.templatesType).then((templates)=>{

      $(`#regularTemplate_${this.modalName}`).show();
      $(`#regularTemplate_${this.modalName}`).removeClass('disabled');
      $(`#customTemplate_${this.modalName}`).hide();
      $(`#customTemplatesBtn_${this.modalName}`).show();
      $(`#footerBlock_${this.modalName}`).show();
      $(`#footerBlock_${this.modalName}`).addClass('d-flex');
      $(`#selTempBlock_${this.modalName}`).show();
      $(`#backgroundBlock_${this.modalName}`).hide();
      $(`#customTemplateHeader_${this.modalName}`).show();

      let templatesArr = []
      if (templates.length) {
        templatesArr = [...templates]
          let activeTemplates =  templates.filter((templete)=>(!templete.status));
          orgMain.initialiseTemplateSelect(activeTemplates,this.modalName,this.eventId, this.templatesType)
      }else{
        orgMain.initialiseTemplateSelect([],this.modalName,this.eventId, this.templatesType)
      }

      $(`#customTemplatesBtn_${this.modalName}`).off("click")
      $(`#customTemplatesBtn_${this.modalName}`).click(function(){
          orgMain.loadEventReminderFirstScreen(self.modalName,self.eventId,self.templatesType)
      })

      if(self.templatesType === orgMain.emailTemplateTypes.Auction){
        if(this.modalName === 'scheduleReminderModal'){
          $('#scheduleReminder_QuillsContainer').hide();
          if(orgMain.selectedTemplate){
            $('#scheduleAllBiddersReminder_noTemplateSelectedErrorMessage').hide();

            return;
          }
        } else if(this.modalName === 'sendReminderModal'){
          if(orgMain.selectedTemplate){
            $('#sendAllBiddersReminder_noTemplateSelectedErrorMessage').hide()
          }

          $(`#regularTemplate_sendReminderModal`).hide()
        }
      }
    })
  }

}
